module.exports = __webpack_public_path__ + "static/media/unit 3-14.dc736642.jpg";